import styles from "./CurrencyConverter.module.css"
import CurrencySelector from "../currencySelector/CurrencySelector"
const CurrencyConverter = (props) => {
  const { isLiq} = props
  return (
      <section className={styles.currency_converter}> 
      {<CurrencySelector direction={isLiq ? "Select Pair" : "From:"}
        field_Id='sell'
        sellToken

      
      />}
          <div className={styles.arrow_container}>
        {isLiq ? null : <span className={styles.arrow} />}
          </div>
      <CurrencySelector direction={isLiq ? null : "To:"}
        field_Id='buy'
        
              />
    </section>
  )
}

export default CurrencyConverter